import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
// 导入路由对应组件
// ******孙彦明************
import GoodsEnter from '../components/goodsEnter/Enter.vue';//登录--孙彦明
import GoodsAddUser from '../components/goodsEnter/Adduser.vue';//注册--孙彦明
import GoodsChangePass from '../components/GoodsEnter/ChangePass.vue';//修改密码--孙彦明
// ********李民杰*********
import Buttom from '../components/pubilc/bottom.vue';//全局底部tab组件--李民杰
import lmjhome from '../components/lmj/home.vue';//首页商品分类--李民杰
import gwhome from '../components/lcx/home.vue';//购物车--鲁晨曦
import shoppingcart from '../components/lcx/shoppingcart.vue';//购物车确认订单--鲁晨曦1
import hyhome from '../components/xy/home.vue';//会员中心--谢宇
import addressmanagement from '../components/xy/addressmanagement.vue';//地址管理--谢宇1
import addresseditor from '../components/xy/addresseditor.vue';//地址编辑--谢宇
import nwaddress from '../components/xy/nwaddress.vue';//地址新增--谢宇
import waitingfororders from '../components/sym/waitingfororders.vue';//待接单--孙彦明
import receivedorders from '../components/sym/receivedorders.vue';//已接单--孙彦明
import DetailsReceived from '../components/sym/DetailsReceived.vue';//待接单详情---孙彦明
import DetailsWaiting from '../components/sym/DetailsWaiting.vue';//待接单详情---孙彦明

Vue.use(Router)

export default new Router({
    mode: 'history',
  routes: [
    { path: '/',name: 'GoodsEnter',component: GoodsEnter},//登录--孙彦明
    { path: '/GoodsAddUser',name: 'GoodsAddUser',component: GoodsAddUser, meta: { skipTokenCheck: true}},//注册--孙彦明
    { path: '/GoodsChangePass',name: 'GoodsChangePass',component: GoodsChangePass},//修改密码--孙彦明
    //全局tab组件--李民杰
    { path: '/buttom',name: 'buttom',component: Buttom,
      children:[
        { path: '/lmjhome',name: 'lmjhome',component: lmjhome},//首页商品分类--李民杰
        { path: '/hyhome',name: 'hyhome',component: hyhome},//会员中心--谢宇
      ]

    },
    { path: '/shoppingcart/:id',name: 'shoppingcart',component: shoppingcart},//购物车确认订单--鲁晨曦
    { path: '/addressmanagement',name: 'addressmanagement',component: addressmanagement},//地址管理--谢宇
    { path: '/addresseditor/:id/:phone/:name/:address/:addr/:status',name: 'addresseditor',component: addresseditor},//地址编辑--谢宇
    { path: '/nwaddress',name: 'nwaddress',component: nwaddress},//地址新增--谢宇
    { path: '/waitingfororders',name: 'waitingfororders',component: waitingfororders},//待接单--孙彦明
    { path: '/receivedorders',name: 'receivedorders',component: receivedorders},//已接单--孙彦明
    { path: '/DetailsReceived/:id',name: 'DetailsReceived',component: DetailsReceived},//待接单详情--孙彦明
    { path: '/DetailsWaiting/:id',name: 'DetailsWaiting',component: DetailsWaiting},//已接单详情--孙彦明
    { path: '/gwhome',name: 'gwhome',component: gwhome}//购物车--鲁晨曦
  ]
})






// WEBPACK FOOTER //
// ./src/router/index.js